import type {
  CountryCodeVO,
  LoginByCodeRequestVO,
  LoginByPasswordRequestVO,
  LoginByVerifyCodeRequestVO,
  LoginByWechatRequestVO,
  LoginResponseVO,
  VerifyCodeRequestVO,
} from '@core/types/login';
import { HT_PLATFORM } from '@core/utils/constant';
import { HETAO_API_BASE } from '@core/utils/environment';
import { httpService } from './http';

const apiPrefix = `${HETAO_API_BASE}/login`;

/**
 * 获取国家区号和手机号验证规则
 */
export function getCountryCodes() {
  return httpService.get<CountryCodeVO[]>(`${apiPrefix}/v2/countryCodes`, {
    headers: httpService.COMMON_HEADERS,
  });
}

/**
 * 带腾讯票据校验的发送验证码接口
 * @headers HT_PLATFORM parentApp
 * @headers HT_SYSTEM android
 * @headers HT_VERSION 2.0.3
 */
export function sendVerifyCode(data: VerifyCodeRequestVO) {
  return httpService.post(
    `${apiPrefix}/v3/account/oauth/verifyCode/htojWeb:Login`,
    {
      body: data,
      headers: httpService.COMMON_HEADERS,
    },
  );
}

/**
 * 手机验证码鉴权（兼微信绑定手机号）
 * 手机号验证码登录
 * @headers HT_PLATFORM parentApp
 * @query mode bindingByUserId
 */
export function loginByVerifyCode(data: LoginByVerifyCodeRequestVO) {
  return httpService.post<LoginResponseVO>(
    `${apiPrefix}/v2/account/oauth/verifyCode`,
    {
      body: data,
      headers: httpService.COMMON_HEADERS,
    },
  );
}

/**
 * 需要轮询用户是否已经扫码登录
 */
export function loginByWechat(data: LoginByWechatRequestVO) {
  return httpService.post<LoginResponseVO>(
    `${apiPrefix}/v2/account/oauth/mobileWeiXin`,
    {
      query: { mode: HT_PLATFORM, openType: 2 },
      body: data,
      headers: httpService.COMMON_HEADERS,
    },
  );
}

/**
 * 通过code登录
 */
export function loginByCode(data: LoginByCodeRequestVO) {
  return httpService.get<LoginResponseVO>(
    `${apiPrefix}/v2/account/oauth/tokenByCode`,
    {
      query: data,
      headers: httpService.COMMON_HEADERS,
    },
  );
}

/**
 * 通过手机号密码登录
 */
export function loginByPassword(data: LoginByPasswordRequestVO) {
  return httpService.post<LoginResponseVO>(
    `${apiPrefix}/v2/account/oauth/password`,
    {
      body: data,
      headers: httpService.COMMON_HEADERS,
    },
  );
}

/**
 * 通过飞书token登录
 */
export function loginByFeishu(staffToken: string, crmStaffId: number) {
  return httpService.post<LoginResponseVO>(
    `${apiPrefix}/v2/account/oauth/staff/token`,
    {
      // body: { staffToken, user_id_tmp: 30207482 },
      body: { staffToken, crmStaffId },
      headers: httpService.COMMON_HEADERS,
    },
  );
}

/**
 * 获取sdk签名
 * 获取appId
 * @headers share-referer
 * @headers Referer
 */
export function getWechatConfigInfo(mode = HT_PLATFORM) {
  return httpService.get<{ appId: string }>(
    `${apiPrefix}/v1/wechat/configInfo`,
    {
      query: { mode },
      headers: httpService.COMMON_HEADERS,
    },
  );
}

/**
 * 更换新的token
 */
export function changeToken(device = HT_PLATFORM) {
  return httpService.get<{ token: string }>(
    `${apiPrefix}/v1/account/changeToken`,
    {
      query: { device },
      headers: httpService.COMMON_HEADERS,
    },
  );
}
